// Helpers partagés de la Base de connaissances.
// Extrait de KnowledgePage.js (refactor 2026-06-12) — zéro changement de logique.

export const TYPE_STYLES = {
  qa: "badge-qa",
  procedure: "badge-procedure",
  script: "badge-script",
  objection: "badge-objection",
  rebuttal: "badge-rebuttal",
  concept: "badge-concept",
  // Vincent B714 (Eric 2026-02-11) — Type "synthesis" ajouté pour l'onglet
  // Synthèses de la Base de connaissances. Badge dédié `badge-synthesis`
  // (teal #14b8a6) miroir de TYPE_COLORS.synthesis dans la timeline vidéo.
  synthesis: "badge-synthesis",
};

// Bogue 1405 (Eric 2026-09-30) — La Base de connaissances plantait en
// anglais : « LIBELLES_TYPE is not defined ». La carte d'une unité appelait
// cette table, qui n'existait NULLE PART — l'écran entier rendait donc la
// page d'erreur, en français comme en anglais (Eric l'a vue en anglais parce
// que c'est là qu'il testait).
//
// Elle vit ici, à côté de `TYPE_STYLES`, parce que les deux décrivent le même
// ensemble de types : posées au même endroit, un type ajouté sans son libellé
// se voit tout de suite. Les deux langues sont sur la même entrée (motif
// 1324b) : ce fichier est hors composant, il ne peut pas appeler le
// traducteur.
export const LIBELLES_TYPE = {
  qa: ["Q&R", "Q&A"],
  procedure: ["Procédure", "Procedure"],
  script: ["Script", "Script"],
  objection: ["Objection", "Objection"],
  rebuttal: ["Réfutation", "Rebuttal"],
  concept: ["Concept", "Concept"],
  synthesis: ["Synthèse", "Synthesis"],
};

// Eric (2026-05-18) — Formatte un timestamp ISO en libellé "il y a Xm/Xh/Xj".
// Utilisé sur chaque carte KU pour afficher "Édité par X il y a Y". Vincent
// veut savoir d'un coup d'œil quelles fiches ont été retravaillées récemment
// vs lesquelles sont restées brutes IA.
export function formatRelativeTime(iso, lang = "fr") {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (isNaN(then)) return "";
  const diff = Math.max(0, Date.now() - then);
  const min = Math.floor(diff / 60000);
  if (min < 1) return lang === "fr" ? "à l'instant" : "just now";
  if (min < 60) return lang === "fr" ? `il y a ${min} min` : `${min}m ago`;
  const h = Math.floor(min / 60);
  if (h < 24) return lang === "fr" ? `il y a ${h} h` : `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 30) return lang === "fr" ? `il y a ${d} j` : `${d}d ago`;
  const mo = Math.floor(d / 30);
  if (mo < 12) return lang === "fr" ? `il y a ${mo} mois` : `${mo}mo ago`;
  const y = Math.floor(mo / 12);
  return lang === "fr" ? `il y a ${y} an${y > 1 ? "s" : ""}` : `${y}y ago`;
}

// Vincent 20/05/2026 — Format historique titre demandé : "AAAA-MM-JJ HH:MM : titre"
// Utilisé partout (Q&R, procédures, scripts, validation rapide) pour cohérence.

// Utilisé partout (Q&R, procédures, scripts, validation rapide) pour cohérence.
export function formatTitleHistoryEntry(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd} ${hh}:${mi}`;
}

